<template>
<div>
  <common-header></common-header>
  <div class="technology">
    <div class="banner">
      <div class="content">
        <div class="clearfix bannerlogo">
          <pub-animate>
            <div v-show="showNavPic" style="height:100%">
              <div class="fl" v-show="showNavPic">
                <h1 class="ft36">{{lanInfo.banner01.title}}</h1>
                <p :class="{'enp':lanType == 'en'}">{{lanInfo.banner01.content}}</p>
              </div>
              <div class="fr">
                <img src="../assets/images/technology/baipishu-baner.png" alt>
              </div>
            </div>
          </pub-animate>
        </div>
      </div>
    </div>
    <div class="expert">
      <div class="con">
        <p class="ft26 title">{{lanInfo.AdviserExpert}}</p>
        <div class="people">
          <div class="item">
            <img src="../assets/images/contact/people_01.png" alt :class="{'enImg':lanType=='en'}">
            <span class="content">
              <p class="name ft18">
                王功权&nbsp;&nbsp;&nbsp;&nbsp;
                <i
                  class="info ft14"
                  :class="{'enInfo':lanType=='en'}"
                >{{lanInfo.FamousInvestor}}</i>
              </p>
              <p
                class="detail ft12 textAlignJus"
                :class="{'enDetail':lanType=='en'}"
              >{{lanInfo.FamousInvestorDscp}}</p>
            </span>
          </div>
          <div class="item">
            <img src="../assets/images/contact/people_02.png" alt :class="{'enImg':lanType=='en'}">
            <span class="content">
              <p class="name ft18">
                方向&nbsp;&nbsp;&nbsp;&nbsp;
                <i
                  class="info ft14"
                  :class="{'enInfo':lanType=='en'}"
                >{{lanInfo.FamousLegalResearch}}</i>
              </p>
              <p
                class="detail ft12 textAlignJus"
                :class="{'enDetail':lanType=='en'}"
              >{{lanInfo.FamousLegalResearchDscp}}</p>
            </span>
          </div>
          <div class="item">
            <img src="../assets/images/contact/people_03.png" alt :class="{'enImg':lanType=='en'}">
            <span class="content">
              <p class="name ft18">
                周政军 &nbsp;&nbsp;&nbsp;&nbsp;
                <i
                  class="info ft14"
                  :class="{'enInfo':lanType=='en'}"
                >{{lanInfo.BlockChainChipExper}}</i>
              </p>
              <p
                class="detail ft12 textAlignJus"
                :class="{'enDetail':lanType=='en'}"
              >{{lanInfo.BlockChainChipExperDscp}}</p>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="book">
      <div class="contentBox clearfix content box" style="background: #fafafa;">
        <pub-animate enterClass="fadeInLeft" @showAnimate="show">
          <div class="fl" v-show="showPic1_left">
            <p class="ft26 title">{{lanInfo.banner01.title}}</p>
            <div class="text">
              <p
                class="ft12 TextIndent textAlignJus"
                style="line-height:28px;"
              >{{lanInfo.ArticlePart1}}</p>
              <p
                class="ft12 TextIndent textAlignJus"
                style="line-height:28px;"
              >{{lanInfo.ArticlePart2}}</p>
              <p
                class="ft12 TextIndent textAlignJus"
                style="line-height:28px;"
              >{{lanInfo.ArticlePart3}}</p>
            </div>
            <a class="downloadText" download target="_blank" :href="download">{{lanInfo.download}} PDF</a>
          </div>
        </pub-animate>
        <pub-animate enterClass="zoomIn" @showAnimate="show">
          <div class="fr" v-show="showPic1_right">
            <img :src="arrImg[indexImg-1].url" alt>
            <div class="page">
              <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page.sync="pageNo"
                :page-size="pageSize"
                :layout="lanType=='cn'?'total, prev, pager, next':'prev, pager, next'"
                :total="this.arrImg.length"
                :prev-text="lanInfo.pre"
                :next-text="lanInfo.next"
              ></el-pagination>
            </div>
          </div>
        </pub-animate>
      </div>
    </div>
  </div>
</div>

</template>

<script>
// 首页
export default {
  data() {
    return {
      showNavPic: false,
      showPic1_left: false,
      showPic1_right: false,
      pageNo: 1,
      pageSize: 1,
      baseUrl: process.env.BASE_URL,
      download: "http://oss.ip360.net.cn/res/files/opendoc/legalXchain_Release_V1.0.pdf",
      arrImg: [
        { url: require("../assets/images/technology/1.jpg") },
        { url: require("../assets/images/technology/2.jpg") },
        { url: require("../assets/images/technology/3.jpg") },
        { url: require("../assets/images/technology/4.jpg") },
        { url: require("../assets/images/technology/5.jpg") },
        { url: require("../assets/images/technology/6.jpg") },
        { url: require("../assets/images/technology/7.jpg") },
        { url: require("../assets/images/technology/8.jpg") },
        { url: require("../assets/images/technology/9.jpg") },
        { url: require("../assets/images/technology/10.jpg") },
        { url: require("../assets/images/technology/11.jpg") },
        { url: require("../assets/images/technology/12.jpg") },
        { url: require("../assets/images/technology/13.jpg") },
        { url: require("../assets/images/technology/14.jpg") },
        { url: require("../assets/images/technology/15.jpg") },
        { url: require("../assets/images/technology/16.jpg") },
        { url: require("../assets/images/technology/17.jpg") },
        { url: require("../assets/images/technology/18.jpg") },
        { url: require("../assets/images/technology/19.jpg") }
      ],
      indexImg: 1
    };
  },
  mounted() {
    setTimeout(() => {
      this.showNavPic = true;
    }, 1);
  },
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.technology;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
  methods: {
    show() {
      setTimeout(() => {
        this.showPic1_left = true;
        this.showPic1_right = true;
      }, 800);
    },
    handleCurrentChange(val) {
      this.indexImg = val;
    }
  }
};
</script>

<style scoped lang="scss">
.technology {
  position: relative;
  z-index: 0;
  .expert {
    width: 100%;
    min-height: 344px;
    background: #fff;
    .con {
      width: 1200px;
      min-height: 304px;
      background: #fff;
      margin: 0 auto;
      padding-top: 40px;
      .people {
        overflow: hidden;
        .item {
          width: 400px;
          float: left;
          margin-top: 10px;
          img {
            display: inline-block;
            vertical-align: top;
          }
          .enImg {
            height: 199px;
            width: 160px;
          }
          .content {
            display: inline-block;
            width: 205px;
            margin-left: 20px;
            .name {
              color: #333333;
              margin-bottom: 10px;
              font-weight: bold;
            }
            .info {
              color: #797979;
              font-style: normal;
              font-weight: normal;
            }
            .enInfo {
              display: inline-block;
              font-size: 13px;
              width: 250px;
            }
            .detail {
              color: #444444;
              line-height: 24px;
            }
            .enDetail {
              line-height: 14px;
            }
            p {
              width: 205px;
            }
          }
        }
      }
      .title {
        display: inline-block;
        border-bottom: 3px solid #0650ca;
      }
    }
  }
  .book {
    width: 100%;
    height: 926px;
    background: #fafafa;
  }
  .content {
    width: 1200px;
    overflow: hidden;
    margin: 0 auto;
  }
  .banner {
    width: 100%;
    background: #0e285a;
     .ft36{
          font-size: 32px;
        }
    .bannerlogo {
      height: 418px;
      .fl {
        width: 728px;
        padding-top: 140px;
        h1{
          font-weight: 400;
        }
        color: #fff;
        p {
          margin-top: 13px;
          line-height: 26px;
          font-size: 14px;
        }
        .enp {
          line-height: 26px;
        }
      }
      .fr {
        width: 472px;
        padding-top: 83px;
      }
    }
  }

  .contentBox {
    padding: 20px 0;
    font-size: 16px;
    box-sizing: border-box;
    .fl {
      width: 500px;
      color: #333333;
      .title {
        border-bottom: 3px solid #0650ca;
        display: inline-block;
        margin-bottom: 20px;
      }
      .text {
        line-height: 34px;
        // height: 420px;
        .first {
          margin-bottom: 10px;
        }
      }
    }
    .fr {
      width: 700px;
      text-align: center;
      margin-top: 10px;
      img {
        width: 600px;
        height: 800px;
        border: 1px solid #ccc;
      }
    }
    .downloadText {
      margin-top: 10px;
      border: 1px solid #0650ca;
      border-radius: 3px;
      text-decoration: none;
      display: inline-block;
      width: 126px;
      line-height: 30px;
      text-align: center;
      color: #0650ca;
      transition: all 0.7s ease-in-out 0s;
      &:hover {
        color: #fff;
        background: #0650ca;
      }
    }
    .page {
      margin-top: 20px;
    }
  }
  img {
    cursor: pointer;
    transition: all 0.7s ease-in-out 0s;
    &:hover {
      transform: scale(1.07, 1.07);
    }
  }
  .box {
    margin: 0px auto;
    height: 926px;
  }
  .textAlignJus{
    text-align: left !important;
  }
}
</style>

<style lang="scss">
.technology {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #0650ca;
    color: #fff !important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #0650ca;
  }
}
</style>
